import { inject } from '@angular/core';

import { AlertsStore } from 'app/alerts/alerts.store';
import { isBrokenSensorsAlert } from 'app/alerts/triggerStateMapping';
import { DeviceId } from 'app/site-detail/models/Device';

export function useResolveBrokenSensorsAlert() {
    const alertsStore = inject(AlertsStore);

    const resolve = async (deviceId: DeviceId): Promise<void> => {
        const alert = alertsStore.getAlertsByDevice(deviceId).find(isBrokenSensorsAlert);
        if (!alert) return;

        await alertsStore.resolve(alert.id);
    };

    return { resolve };
}
